import amls1 from "../assets/images/about/amls-01.jpg";
import amls2 from "../assets/images/about/amls-02.jpg";
import amls3 from "../assets/images/about/amls-03.jpg";
import amls4 from "../assets/images/about/amls-04.jpg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Study() {
  const navigate = useNavigate();

  const [newsData, setNewsData] = useState([]);
  const [allgallary, setGallary] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [filteredImages, setFilteredImages] = useState([]);
  const [activeFilter, setActiveFilter] = useState("all");

  const BASE_URL = process.env.REACT_APP_BASE_API_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!BASE_URL) return;

        /* ================= NEWS ================= */
        const newsRes = await axios.get(
          `${BASE_URL}/api/auth/get/getallNews`
        );
        setNewsData(Array.isArray(newsRes.data) ? newsRes.data : []);

        /* ================= GALLERY CATEGORIES ================= */
        const categoryRes = await axios.get(
          `${BASE_URL}/api/auth/list/GallerycategoryMaster`
        );

        const activeCategories = Array.isArray(categoryRes.data)
          ? categoryRes.data.filter(item => item.IsActive).slice(0, 4)
          : [];

        setGallary(activeCategories);

        /* ================= GALLERY IMAGES ================= */
        const imagesRes = await axios.get(
          `${BASE_URL}/api/auth/AllGalleryMaster`
        );

        const activeImages = Array.isArray(imagesRes.data)
          ? imagesRes.data.filter(img => img.IsActive)
          : [];

        setGalleryImages(activeImages);

        /* ===== DEFAULT (ALL) – first 3 images per category ===== */
        const categoryGroups = {};
        activeImages.forEach(img => {
          const categoryId = img.Title?._id;
          if (!categoryId) return;

          if (!categoryGroups[categoryId]) {
            categoryGroups[categoryId] = [];
          }
          categoryGroups[categoryId].push(img);
        });

        const allImages = [];
        Object.values(categoryGroups).forEach(images => {
          allImages.push(...images.slice(0, 3));
        });

        setFilteredImages(allImages);

      } catch (error) {
        console.error("Study page error:", error);
      }
    };

    fetchData();
  }, [BASE_URL]);

  /* ================= FILTER ================= */
  const filterGallery = (categoryId) => {
    setActiveFilter(categoryId);

    if (categoryId === "all") {
      const groups = {};
      galleryImages.forEach(img => {
        const id = img.Title?._id;
        if (!id) return;

        if (!groups[id]) groups[id] = [];
        groups[id].push(img);
      });

      const result = [];
      Object.values(groups).forEach(images => {
        result.push(...images.slice(0, 3));
      });

      setFilteredImages(result);
    } else {
      const filtered = galleryImages
        .filter(img => img.Title?._id === categoryId)
        .slice(0, 3);

      setFilteredImages(filtered);
    }
  };

  const gallaryChange = (id) => {
    if (!id) return;
    localStorage.setItem("gallaryId", id);
    navigate("/innerGallary");
  };

  return (
    <>
      {/* ================= STUDY AREA ================= */}
      <section className="study-area pt-100 pb-70">
        <div className="container">
          <div className="section-title white-title text-center">
            <h2>Millennium Learning System (MLS)</h2>
            <p>UNIQUE FEATURES OF OUR PROGRAMS</p>
          </div>

          <div className="row justify-content-center">
            {[
              { img: amls1, title: "LITTLE MILLENNIUM" },
              { img: amls2, title: "MLS I" },
              { img: amls3, title: "MLS II" },
              { img: amls4, title: "MLS III" },
            ].map((item, index) => (
              <div className="col-lg-3 col-md-6 mb-4" key={index}>
                <div className="team">
                  <div className="team-img">
                    <img className="img-fluid" src={item.img} alt={item.title} />
                  </div>
                  <div className="team-info">
                    <Link to="/learningSystem" className="team-name">
                      {item.title}
                    </Link>
                    <p className="team-leader">
                      <Link to="/millennium-learning-system" className="team-name" style={{ color: "#039725" }}>
                        See More
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= NEWS ================= */}
      {newsData.length > 0 && (
        <section className="news-section">
          <div className="container">
            <div className="row mb-4">
              <div className="col-md-7 col-6">
                <div className="section-title">
                  <h2>NEWS & EVENTS</h2>
                </div>
              </div>
              <div className="col-md-5 col-6 text-md-right">
                <Link className="btn btn-primary btn-round" to="/news-and-events">
                  View All
                </Link>
              </div>
            </div>

            <div className="row">
              {newsData.slice(0, 4).map((data) => {
                const dateVal = data.date || data.createdAt;
                const dateObj = dateVal ? new Date(dateVal) : null;

                return (
                  <div className="col-lg-6 mt-4" key={data._id}>
                    <div className="blog-post d-flex align-items-center shadow border-radius">
                      <div className="blog-date text-center">
                        <h3 className="mb-1">{dateObj ? dateObj.getDate() : "--"}</h3>
                        <span className="d-block mb-1">{dateObj ? dateObj.toLocaleString("default", { month: "short" }) : "--"}</span>
                        <span className="d-block">{dateObj ? dateObj.getFullYear() : "--"}</span>
                      </div>
                      <div className="blog-contant">
                        <h5>
                          <Link to={`/dynamicNews/${data._id}`}>
                            {data.Title && data.Title.length > 60 ? `${data.Title.substring(0, 60)}...` : data.Title}
                          </Link>
                        </h5>
                        <Link to="/news-and-events">View Details</Link>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {/* ================= GALLERY ================= */}
      <section className="space-ptb">
        <div className="container">
          <div className="row mb-4">
            <div className="col-md-7 col-6">
              <div className="section-title">
                <h2>Our Gallery</h2>
              </div>
            </div>
            <div className="col-md-5 col-6 text-md-right">
              <Link className="btn btn-primary btn-round" to="/photo-gallery">
                View More
              </Link>
            </div>
          </div>

          <div className="filters-group text-center mb-4">
            <button
              className={`btn-filter ${activeFilter === "all" ? "active" : ""}`}
              onClick={() => filterGallery("all")}
            >
              All
            </button>

            {allgallary.map(item => (
              <button
                key={item._id}
                className={`btn-filter ${activeFilter === item._id ? "active" : ""}`}
                onClick={() => filterGallery(item._id)}
              >
                {item.Title}
              </button>
            ))}
          </div>

          <div className="row">
            {filteredImages.length > 0 ? (
              filteredImages.map((event) => (
                <React.Fragment key={event._id}>
                  {Array.isArray(event.File) &&
                    event.File.slice(0, 3).map((img, index) => (
                      <div className="col-lg-4 col-md-6 mb-4" key={event._id + index}>
                        <div
                          className="gallery-item"
                          style={{ cursor: "pointer" }}
                          onClick={() => gallaryChange(event.Title?._id)}
                        >
                          <img
                            src={`${BASE_URL}/${img}`}
                            alt={event.Title?.Title || "Gallery"}
                            style={{
                              width: "100%",
                              height: "300px",
                              objectFit: "cover",
                            }}
                            onError={(e) => {
                              e.target.src = "https://via.placeholder.com/400x300";
                            }}
                          />
                        </div>
                      </div>
                    ))}
                </React.Fragment>
              ))
            ) : (
              <div className="col-12 text-center py-5">
                <p className="text-muted">No images found</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
